import { render, staticRenderFns } from "./DragWrapper.vue?vue&type=template&id=445acf90&"
import script from "./DragWrapper.vue?vue&type=script&lang=js&"
export * from "./DragWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports